module.exports = __webpack_public_path__ + "img/other_grey_en.59f9ede3.svg";